import React from 'react';
import styled from 'styled-components';

const handleColorType = (module, theme) => {
	switch (module) {
		case 'storage':
			return theme.storage;
		case 'account':
			return theme.account;
		case 'billing':
			return theme.billing;
		case 'support':
			return theme.support;
		case 'colocation':
			return theme.colocation;
		default:
			return theme.main;
	}
};

const MonthlySVG = styled.svg`
	width: 14px;
	height: 20px;
	margin-right: 2px;

	.monthly {
		fill: #a2a9ad;
	}
`;

export const MonthlySelector = props => {
	const { id, theme, module, position, className } = props;
	const rotate = position === 'left' ? 'rotate(90)' : 'rotate(270)';

	return (
		<MonthlySVG id={id} module={module} width='8.578' height='8.582' viewBox='0 0 8.578 8.582'>
			<defs>
				<linearGradient
					id={`${id}-swipe-gradient`}
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform={rotate}
				>
					<stop offset='0' stop-color='white'>
						<animate
							id={`${id}trans1`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color={handleColorType(module, theme)}>
						<animate
							id={`${id}trans1`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
			</defs>
			<path
				id='Monthly-Calendar'
				d='M202.233 213.894a.56.56 0 0 0 .4.163.557.557 0 0 0 .561-.561.56.56 0 0 0-.163-.4.562.562 0 0 0-.791 0 .556.556 0 0 0 0 .792zm.278-.516a.173.173 0 0 1 .118-.048.169.169 0 0 1 .118.048.168.168 0 0 1 0 .235.173.173 0 0 1-.118.048.166.166 0 0 1-.118-.283zm-.278 2.01a.556.556 0 0 0 .791 0 .562.562 0 0 0 0-.792.556.556 0 0 0-.791 0 .556.556 0 0 0 0 .792zm.278-.513a.171.171 0 0 1 .118-.046.167.167 0 0 1 .118.046.154.154 0 0 1 .048.115.159.159 0 0 1-.048.118.169.169 0 0 1-.118.048.173.173 0 0 1-.118-.048.169.169 0 0 1-.048-.118.163.163 0 0 1 .048-.115zm2.768-.981a.56.56 0 0 0 .4.163.56.56 0 0 0 .4-.957.57.57 0 0 0-.4-.163.56.56 0 0 0-.4.163.562.562 0 0 0-.165.4.571.571 0 0 0 .163.4zm.278-.516a.168.168 0 0 1 .235 0 .168.168 0 0 1 0 .235.174.174 0 0 1-.118.048.169.169 0 0 1-.118-.048.168.168 0 0 1 0-.235zm-1.8.516a.565.565 0 0 0 .794 0 .566.566 0 0 0 .163-.4.56.56 0 0 0-.163-.4.562.562 0 0 0-.791 0 .562.562 0 0 0 0 .792zm.278-.516a.165.165 0 0 1 .118-.048.169.169 0 0 1 .118.048.168.168 0 0 1 0 .235.169.169 0 0 1-.118.048.165.165 0 0 1-.118-.048.168.168 0 0 1 0-.235zm-1.8 3.5a.556.556 0 0 0 .791 0 .562.562 0 0 0 .163-.4.569.569 0 0 0-.163-.4.562.562 0 0 0-.791 0 .559.559 0 0 0 0 .794zm.278-.513a.165.165 0 0 1 .118-.05.161.161 0 0 1 .118.05.154.154 0 0 1 .048.115.155.155 0 0 1-.048.118.169.169 0 0 1-.118.048.173.173 0 0 1-.118-.048.165.165 0 0 1 0-.233zm4.84-6.646h-7.92a.332.332 0 0 0-.331.331v7.92a.332.332 0 0 0 .331.331h7.92a.33.33 0 0 0 .329-.331v-7.92a.33.33 0 0 0-.329-.331zm-.331 7.92h-7.26v-5.332h7.26v5.332zm0-5.73h-7.26v-1.528h.65v.492a.33.33 0 0 0 .66 0v-.492h1.108v.492a.33.33 0 0 0 .66 0v-.492h1.106v.492a.33.33 0 0 0 .66 0v-.492h1.108v.492a.33.33 0 0 0 .66 0v-.492h.65v1.528zm-3.264 4.97a.556.556 0 0 0 .791 0 .562.562 0 0 0 .163-.4.569.569 0 0 0-.163-.4.562.562 0 0 0-.791 0 .565.565 0 0 0 0 .794zm.278-.513a.157.157 0 0 1 .118-.05.161.161 0 0 1 .118.05.154.154 0 0 1 .048.115.155.155 0 0 1-.048.118.169.169 0 0 1-.118.048.164.164 0 0 1-.118-.048.155.155 0 0 1-.048-.118.154.154 0 0 1 .048-.115zm-3.327-.981a.573.573 0 0 0 .4.165.562.562 0 0 0 .4-.165.562.562 0 0 0 0-.792.553.553 0 0 0-.4-.165.562.562 0 0 0-.4.165.562.562 0 0 0 0 .792zm.281-.513a.163.163 0 0 1 .118-.046.167.167 0 0 1 .118.046.163.163 0 0 1 .048.115.169.169 0 0 1-.048.118.169.169 0 0 1-.118.048.165.165 0 0 1-.118-.048.169.169 0 0 1-.048-.118.163.163 0 0 1 .048-.115zm-.281 2.007a.572.572 0 0 0 .4.165.562.562 0 0 0 .4-.165.562.562 0 0 0 .163-.4.569.569 0 0 0-.163-.4.55.55 0 0 0-.4-.163.56.56 0 0 0-.4.163.565.565 0 0 0 0 .794zm.281-.513a.157.157 0 0 1 .118-.05.161.161 0 0 1 .118.05.165.165 0 0 1 0 .233.169.169 0 0 1-.118.048.164.164 0 0 1-.118-.048.165.165 0 0 1 0-.233zm2.768-.981a.556.556 0 0 0 .791 0 .562.562 0 0 0 0-.792.556.556 0 0 0-.791 0 .562.562 0 0 0 0 .792zm.278-.513a.163.163 0 0 1 .118-.046.167.167 0 0 1 .118.046.154.154 0 0 1 .048.115.159.159 0 0 1-.048.118.169.169 0 0 1-.118.048.165.165 0 0 1-.118-.048.159.159 0 0 1-.048-.118.154.154 0 0 1 .048-.115zm1.245.513a.562.562 0 0 0 .4.165.572.572 0 0 0 .4-.165.556.556 0 0 0 0-.792.562.562 0 0 0-.4-.165.552.552 0 0 0-.4.165.556.556 0 0 0 0 .792zm.278-.513a.174.174 0 0 1 .235 0 .163.163 0 0 1 .048.115.169.169 0 0 1-.048.118.168.168 0 0 1-.235 0 .159.159 0 0 1-.048-.118.154.154 0 0 1 .048-.115z'
				class={className}
				transform='translate(-199.101 -209.723)'
			/>
		</MonthlySVG>
	);
};
